import api from './api'

// Типы
export interface FreezeRequest {
  days?: number
  reason?: string
}

export interface BlockRequest {
  reason?: string
}

export interface ClientStatusResponse {
  message: string
  status: string
  freeze_until?: string
}

// API для управления клиентами тренером

export async function freezeClient(
  clientId: string,
  data: FreezeRequest
): Promise<ClientStatusResponse> {
  const response = await api.post<ClientStatusResponse>(
    `/trainers/me/clients/${clientId}/freeze`,
    data
  )
  return response.data
}

export async function unfreezeClient(clientId: string): Promise<ClientStatusResponse> {
  const response = await api.post<ClientStatusResponse>(
    `/trainers/me/clients/${clientId}/unfreeze`
  )
  return response.data
}

export async function blockClient(
  clientId: string,
  data: BlockRequest
): Promise<ClientStatusResponse> {
  const response = await api.post<ClientStatusResponse>(
    `/trainers/me/clients/${clientId}/block`,
    data
  )
  return response.data
}

export async function unblockClient(clientId: string): Promise<ClientStatusResponse> {
  const response = await api.post<ClientStatusResponse>(
    `/trainers/me/clients/${clientId}/unblock`
  )
  return response.data
}
